import styled, { css } from "styled-components";

interface PhotoGuideItemProps {
  $text?: boolean;
}

export const PhotoGuideItem = styled.li<PhotoGuideItemProps>`
  overflow: hidden;
  width: 100%;
  height: calc(100vh - 356px);
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.shadows.box};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }

  ${(props) =>
    props.$text === true &&
    css`
      display: grid;
      padding: 20px;
      grid-template-rows: auto 66px;
      gap: 10px;

      img {
        max-height: calc(100vh - 472px);
      }
    `}
`;

export const PhotoGuideText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 6px;

  & > div {
    font-size: 1.5rem;
    line-height: 150%;
    text-align: center;

    b {
      color: ${(props) => props.theme.colors.primary100};
      font-weight: 800;
    }
  }

  & > span {
    color: ${(props) => props.theme.colors.bright100};
    font-size: 1.3rem;
    font-weight: 700;
  }
`;
